module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/tactical-training-cancel.3b214c8f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/tactical-training-cancel.png
// module id = 3749
// module chunks = 11